import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosAddGiftcardModalService } from 'src/app/@core/services/pos-add-giftcard-modal.service';
import { PosAddGiftcardModalComponent } from './pos-add-giftcard-modal.component';



@NgModule({
  declarations: [
    PosAddGiftcardModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskModule
  ],
  providers: [PosAddGiftcardModalService],
  exports: [PosAddGiftcardModalComponent]
})
export class PosAddGiftcardModalModule { }
